import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Post } from "libs/services";
import CryptoES from "crypto-es";
import { PaymentRequest } from "src/common/libs/types/PaymentRequest";
import { PAYMENT } from "src/common/libs/config/payment.config";

import { openToast } from "./toast";
import { PRV_KEY } from "src/common/libs/utils/constants";
import moment from "moment";
import { reportLog } from "src/common/libs/utils/logs";

interface AuthState {
  token: {
    token: string;
    refreshToken: string;
  };
}

export const initiatePaymentWeb = createAsyncThunk(
  "payment/initiate",
  async (payload: PaymentRequest, thunkAPI) => {
    try {
      const encryptedPayload = CryptoES.AES.encrypt(
        JSON.stringify({ ...payload, date: moment().unix() }),
        PRV_KEY
      ).toString();
      const response = await Post(PAYMENT.post, {
        data: encryptedPayload,
      });
      return response.data;
    } catch (error) {
      reportLog({
        error: error,
        location: "features/payment->initiatePaymentWeb",
        body: {},
      });
      thunkAPI.dispatch(
        openToast({ message: error.response?.data?.message || error.message })
      );
      throw error;
    } finally {
      // thunkAPI.dispatch(setLoading(false));
    }
  }
);

const initialState: AuthState = {
  token: null,
};

export const paymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {},
});

export default paymentSlice.reducer;
